<app-page-meta pageTitle="finzy - Investment Application"></app-page-meta>
<app-header></app-header>
<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <app-lenderleftdiv></app-lenderleftdiv>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="mobileleftdiv">
      <app-lender-registration-progress-bar></app-lender-registration-progress-bar>
    </div>
    <div class="rightinnerdiv">
      <p class="headtxt">Bank details</p>
      <p class="ptxt4">Provide us your bank details so that we can send the returns on your investment to the right
        place.</p>
      <p class="ptxt4">Your bank details are entirely safe and are stored in an encrypted format.</p>

      <app-lenderbankdetail (on-bank-details-submit)="onSubmit($event)"
                            back-button-link="/invest/residence-info"
                            [pre-filled-bank-data]="preFilledBankDetails"
                            (onSearchBankByIfsc)="analyticsTracker.trackButtonClick('Lender Bank Details', 'Search Bank By IFSC')"
                            (onNext)="analyticsTracker.trackButtonClick('Lender Bank Details', 'NEXT')">>
      </app-lenderbankdetail>

    </div>
  </div>
</div>

<app-footer></app-footer>
